"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ConfigProps = void 0;
var ConfigProps = exports.ConfigProps = {
  ActivateAdobeTargetDIVTagSafeZones: "Activate Adobe Target DIV Tag Safe Zones"
};
//# sourceMappingURL=configProps.js.map